import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const GoodReceiptNote = () => {
  return (
    <PrintPreferenceTabs type="good_receipt_note"></PrintPreferenceTabs>
  );
};
export default GoodReceiptNote;
